import { ReactNode } from 'react'
import { LayoutHeader } from './header/'
import { LayoutFooter } from './footer'
import { LayoutBanner } from './banner'

interface LayoutProps {
  children: ReactNode
  notFound?: '' | 'vacancy-page' | 'company-page'
}

export const Layout = ({ children, notFound = '' }: LayoutProps) => {
  if (notFound) {
    return (
      <div className="flex flex-col min-h-screen items-stretch">
        <span className="bg-[#FFF7CD] text-center p-4 font-medium">
          Estamos enfrentando uma instabilidade e estamos focados em resolver o
          problema o mais rápido possível. Recomendamos que tente novamente mais
          tarde.
        </span>
        {notFound === 'vacancy-page' && <LayoutHeader />}
        {children}
        <LayoutFooter />
      </div>
    )
  }

  return (
    <div className="flex flex-col min-h-screen items-stretch">
      <span className="bg-[#FFF7CD] text-center p-4 font-medium">
        Estamos enfrentando uma instabilidade e estamos focados em resolver o
        problema o mais rápido possível. Recomendamos que tente novamente mais
        tarde.
      </span>
      <LayoutHeader />
      <main className="flex-1 bg-gray-100 relative s-content">
        <LayoutBanner />
        <div className="relative z-[2] w-full flex flex-col">{children}</div>
      </main>
      <LayoutFooter />
    </div>
  )
}
